import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(private http: HttpClient) { }

    insertUserFromAccount() {
        return this.http.post<any>(
            environment.beServiceUrl +
            `/v1/user/insert-from-account`,
            null
        );
    }
}